import React from 'react'

import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import PageRoutes from '@utils/page-routes'

const GeneralSection: React.FC = () => {
  const { t } = useTranslation()
  return (
    <ul className="p-2.5 basis-1/2 sm:basis-[auto]">
      <li className="font-medium text-md mb-0.5">Noteflight</li>
      <li className="py-0.5">
        <Link to={PageRoutes.plansPath()} className="link" reloadDocument>
          {t('footer.general.plans')}
        </Link>
      </li>
      <li className="py-0.5">
        <Link to={PageRoutes.premiumPath()} className="link" reloadDocument>
          {t('footer.general.premium')}
        </Link>
      </li>
      <li className="py-0.5">
        <Link to={PageRoutes.learnPath()} className="link" reloadDocument>
          {t('footer.general.learn')}
        </Link>
      </li>
      <li className="py-0.5">
        <Link to={PageRoutes.soundcheckPath()} className="link" reloadDocument>
          {t('footer.general.soundcheck')}
        </Link>
      </li>
      <li className="py-0.5">
        <Link to={PageRoutes.higherEdPath()} className="link" reloadDocument>
          {t('footer.general.higherEd')}
        </Link>
      </li>
      <li className="py-0.5">
        <Link to={PageRoutes.giftCardPath()} className="link" reloadDocument>
          {t('footer.general.giftCard')}
        </Link>
      </li>
      <li className="py-0.5">
        <Link to={PageRoutes.partnersPath()} className="link" reloadDocument>
          {t('footer.general.partners')}
        </Link>
      </li>
      <li className="py-0.5">
        <Link to={PageRoutes.developersPath()} className="link" reloadDocument>
          {t('footer.general.developers')}
        </Link>
      </li>
    </ul>
  )
}

export default GeneralSection
